import { CheckOutlined, RightOutlined } from '@ant-design/icons';
import { Badge, Col, Space } from 'antd';
import { CSSProperties, useState } from 'react';
import Lottie from 'react-lottie-player';
import { colors, toRgb } from '../../styles/colors';

interface Props {
  lottieFile: object;
  title: string;
  complete: boolean | null;
  speed?: number;
  required?: boolean;
  /** Icon-only: no visible title and no chevron. The title stays in the DOM as zero-width text: the accessible name. */
  compact?: boolean;
  /** Render a static 25x25 box in place of the Lottie player. For invisible measuring copies only. */
  placeholderIcon?: boolean;
}

const iconStyle: CSSProperties = { height: 25, width: 25, marginBottom: 2 };

/**
 * The compact title stays in the flow, only zero-width. Like the visible title it inherits the menu's line-height, so
 * an icon-only step is exactly as tall as a labelled one and its icon sits on the same centre line. Taken out of the
 * flow (position: absolute), the item shrinks to the 27px icon column and the baseline alignment lifts the icon 6.5px.
 */
const zeroWidthTitle: CSSProperties = { width: 0, overflow: 'hidden', whiteSpace: 'nowrap' };

export const LottieIcon = ({ lottieFile, complete, speed, title, required, compact = false, placeholderIcon = false }: Props): JSX.Element => {
  const [playLottie, setPlayLottie] = useState(false);

  return (
    <Space align="center" onMouseEnter={(): void => setPlayLottie(true)} onMouseLeave={(): void => setPlayLottie(false)}>
      <Col style={{ display: 'flex', alignItems: 'center' }}>
        <Badge dot={required ? Boolean(!complete) : false} style={{ marginBottom: 5 }}>
          {placeholderIcon ? (
            <div style={iconStyle} />
          ) : (
            <Lottie speed={speed || 1} goTo={playLottie === false ? 0 : undefined} loop={false} animationData={lottieFile} play={playLottie} style={iconStyle} />
          )}
        </Badge>
        {compact ? <span style={zeroWidthTitle}>{title}</span> : null}
      </Col>
      {compact ? null : <div>{title}</div>}
      {complete ? <CheckOutlined style={{ color: toRgb(colors.illuminatingEmerald) }} /> : null}
      {compact ? null : <RightOutlined />}
    </Space>
  );
};
